import { CanDeactivateFn } from '@angular/router';
import type { Import } from './import';

/**
 * Reviewed rows only exist in memory until "Import N expenses" is clicked, so navigating away
 * (sidebar nav, back button, deep link) would silently discard whatever the user just
 * categorized. `import type` here keeps the Import component out of this guard's own bundle -
 * the route's `loadComponent` chunk still lazy-loads it separately.
 */
export const unsavedImportGuard: CanDeactivateFn<Import> = (component) => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }
  return window.confirm(
    "You've reviewed transactions that haven't been imported yet. Leaving this page now will discard them - leave without importing?",
  );
};
